export enum SsbActions {
  Reset = "reset",
  FetchSSBSubject = "fetchSSBSubject",
  fetchCountries = "fetchCountries",
}
